module.exports = window.initializeRemote('lift_stations');